import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Badge,
  Card,
  CardHeader,
  CardBody,
  Container,
  FormSelect,
} from "shards-react";
import { useHistory } from "react-router-dom"; // Import useHistory for navigation
import "./LatestOrders.css"; // Import the CSS styles
import { useAuth } from '../../context/AuthContext';

const LatestOrders = ({ title }) => {
  const { login } = useAuth(); 
  const { logout } = useAuth(); 
  

  const [latestOrdersData, setLatestOrdersData] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [packageList, setPackageList] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7; // Number of rows per page
  const history = useHistory(); // Initialize useHistory for navigation
  const [loading, setLoading] = useState(false); // Added for loader

  useEffect(() => {
    const packagesFromStorage = JSON.parse(localStorage.getItem("packages")) || [];
    setPackageList(packagesFromStorage);

    // Auto-select the first package if available
    if (packagesFromStorage.length > 0) {
      setSelectedPackage(packagesFromStorage[0]);
    }
  }, []);

  useEffect(() => {
    if (selectedPackage) {
      fetchData(selectedPackage);
    }
  }, [selectedPackage]);

  const fetchData = async (packageName) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const comp_id=localStorage.getItem('company_id');
     // const token=localStorage.getItem('token');
      
      if(!comp_id||comp_id==''||!token||token==''){ 
       logout();
     }

      const response = await fetch(
        "https://vaptlabreport.com/shieldapi/metrics_per_package.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ package_name: [packageName] }),
        }
      );

      const apiData = await response.json();

      if (apiData.status === "error") {
        setError("No data for this package.");
        setLatestOrdersData([]);
      } else {
        setError("");
        setLatestOrdersData(apiData.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("An error occurred while fetching data.");
      setLatestOrdersData([]);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const handlePackageChange = (e) => {
    setSelectedPackage(e.target.value);
    setCurrentPage(1); // Reset to first page when package changes
  };

  const getSeverityColor = (severity) => {
    switch (severity?.toLowerCase()) {
      case "low":
        return "#92d051";
      case "medium":
        return "#fec100";
      case "high":
        return "#ff0000";
      case "critical":
        return "#c00000";
      default:
        return "#08b4f4";
    }
  };

  // const determineSeverity = (item) => {
  //   return item.isRooted === "1" ? "Critical" : "Low"; // Example logic
  // };


  // const determineSeverity = (item) => {
  //   let severity = "Low"; // Default severity
  //   if (item.isRooted === 1) {
  //     severity = "Critical";
  //   } else if (item.isEmulator === 1) {
  //     severity = "Medium";
  //   } else if (item.isUsbDebuggingEnabled === 1 || item.isDeveloperOptionsEnabled === 1) {
  //     severity = "Medium";
  //   }
  //   return severity;
  // };

  const determineSeverity = (item) => {
    let severity = "Low"; // Default severity
  
    // Define severity mapping based on detections
    const detectionSeverityMap = {
      isRooted: "Critical",  // Root detected is critical
      isEmulator: "Medium",  // Emulator detected is medium
      isUsbDebuggingEnabled: "Low", // USB Debugging Enabled is low
      is_usb_connected: "Low", // USB connected is low
      isDeveloperOptionsEnabled: "Medium",  // Developer Options Enabled is medium
      isProxyEnabled: "High", // Proxy Enabled is high
      isDebugging: "Medium", // Debugging Enabled is medium
      isMockLocationEnabled: "High", // Mock Location Enabled is high
      isInstalledFromValidSource: "High", // Installed from invalid source is high
      isVPNEnabled: "Medium", // VPN Enabled is medium
      isHooking: "High", // Hooking Detected is high
      isScreenshotDetected: "Medium", // Screenshot Detected is medium
      isTampered: "High", // App Tampered is high
      isScreenRecording: "Medium", // Screen Recording Detected is medium
      isAppCloned: "High", // App Cloned is high
    };
  
    // Loop through detection keys and find the highest severity
    Object.keys(detectionSeverityMap).forEach((key) => {
      if (key in item && (item[key] === 1 || item[key] === "1" || item[key] === true)) {
        // Update the severity if the detection is active
        const detectionSeverity = detectionSeverityMap[key];
        // If the detection has a higher severity, update the severity level
        if (
          (severity === "Low" && detectionSeverity !== "Low") ||
          (severity === "Medium" && detectionSeverity === "High") ||
          (severity === "Low" && detectionSeverity === "High")
        ) {
          severity = detectionSeverity;
        }
      }
    });
  
    return severity;
  };
  

  // const renderDetections = (item) => {
  //   const detectionSeverityMap = {
  //     isRooted: { label: "Root Detected", severity: "High" },
  //     isEmulator: { label: "Emulator Detected", severity: "Medium" },
  //     isUsbDebuggingEnabled: { label: "USB Debugging Enabled", severity: "Low" },
  //     is_usb_connected: { label: "USB Connected", severity: "Low" },
  //     isDeveloperOptionsEnabled: { label: "Developer Options Enabled", severity: "Medium" },
  //     isProxyEnabled: { label: "Proxy Enabled", severity: "High" },
  //     isDebugging: { label: "Debugging Enabled", severity: "Medium" },
  //   };

  //   return Object.keys(detectionSeverityMap).map((key) => {
  //     if (item[key] === "1") {
  //       const detection = detectionSeverityMap[key];
  //       return (
  //         <span
  //           key={key}
  //           className={`detection-badge badge-${detection.severity.toLowerCase()}`}
  //         >
  //           {detection.label}
  //         </span>
  //       );
  //     }
  //     return null;
  //   });
  // };


  // const renderDetections = (item) => {
  //   const detectionSeverityMap = {
  //     isRooted: { label: "Root Detected", severity: "High" },
  //     isEmulator: { label: "Emulator Detected", severity: "Medium" },
  //     isUsbDebuggingEnabled: { label: "USB Debugging Enabled", severity: "Low" },
  //     is_usb_connected: { label: "USB Connected", severity: "Low" },
  //     isDeveloperOptionsEnabled: { label: "Developer Options Enabled", severity: "Medium" },
  //     isProxyEnabled: { label: "Proxy Enabled", severity: "High" },
  //     isDebugging: { label: "Debugging Enabled", severity: "Medium" },
  //   };

  //   const detections = [];

  //   Object.keys(detectionSeverityMap).forEach((key) => {
  //     if (item[key] === "1") {
  //       const detection = detectionSeverityMap[key];
  //       detections.push(
  //         <span key={key} className={`detection-badge badge-${detection.severity.toLowerCase()}`}>
  //           {detection.label}
  //         </span>
  //       );
  //     }
  //   });

  //   // If no detections found, show a "No detections" message
  //   if (detections.length === 0) {
  //     detections.push(<span key="no-detection" className="detection-badge badge-info">No Detections</span>);
  //   }

  //   return detections;
  // };
  

  const renderDetections = (item) => {
    const detectionSeverityMap = {
      isRooted: { label: "Root Detected", severity: "High" },
      isEmulator: { label: "Emulator Detected", severity: "Medium" },
      isUsbDebuggingEnabled: { label: "USB Debugging Enabled", severity: "Low" },
      is_usb_connected: { label: "USB Connected", severity: "Low" },
      isDeveloperOptionsEnabled: { label: "Developer Options Enabled", severity: "Medium" },
      isProxyEnabled: { label: "Proxy Enabled", severity: "High" },
      isDebugging: { label: "Debugging Enabled", severity: "Medium" },
      isMockLocationEnabled: { label: "Mock Location Enabled", severity: "High" },
      isInstalledFromValidSource: { label: "Installed From Invalid Source", severity: "High" },
      isVPNEnabled: { label: "VPN Enabled", severity: "Medium" },
      isHooking: { label: "Hooking Detected", severity: "High" },
      isScreenshotDetected: { label: "Screenshot Detected", severity: "Medium" },
      isTampered: { label: "App Tampered", severity: "High" },
      isScreenRecording: { label: "Screen Recording Detected", severity: "Medium" },
      isAppCloned: { label: "App Cloned", severity: "High" },
    };
  
    const detections = [];
  
    Object.keys(detectionSeverityMap).forEach((key) => {
      // Check for presence of detection flags and compare accordingly
      if (key in item && (item[key] === 1 || item[key] === "1" || item[key] === true)) {
        const detection = detectionSeverityMap[key];
        detections.push(
          <span key={key} className={`detection-badge badge-${detection.severity.toLowerCase()}`}>
            {detection.label}
          </span>
        );
      }
    });
  
    // If no detections found, show a "No detections" message
    if (detections.length === 0) {
      detections.push(<span key="no-detection" className="detection-badge badge-info">No Detections</span>);
    }
  
    return detections;
  };
  

  const renderDeviceName = (deviceInfo) => {
    return (
      <span className="device-badge">
        {deviceInfo.brand} {deviceInfo.model}
      </span>
    );
  };

  const renderDeviceVersion = (item) => {
    return (
      <span className="device-badge">
        {item.android_api_level ? `${item.android_api_level} (API ${item.android_version})` : "Unknown"}
      </span>
    );
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = latestOrdersData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(latestOrdersData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Handle row click to navigate to device details
  const handleRowClick = (uuid) => {
    history.push(`/devicedetails?uuid=${uuid}`);
  };


  function formatReceivedAt(datetime) {
    const date = new Date(datetime);
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format
    const seconds = String(date.getSeconds()).padStart(2, '0'); // Add seconds
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${ampm}`;
  }

  return (
    <Card small className="lo-stats h-100">
      <CardHeader className="border-bottom d-flex justify-content-between align-items-center">
        <h6 className="m-0">{title}</h6>
        <FormSelect
          size="sm"
          style={{ maxWidth: "200px", fontWeight: "bold", fontFamily: "system-ui", backgroundColor: "#2962ff", color: "white" }}
          value={selectedPackage}
          onChange={handlePackageChange}
        >
          <option value="" style={{ fontWeight: "normal" }}>Select Package</option>
          {packageList.map((pkg, idx) => (
            <option key={idx} value={pkg} style={{ fontWeight: "bold" }}>
              {pkg}
            </option>
          ))}
        </FormSelect>
      </CardHeader>

      <CardBody className="p-0">
        <Container fluid className="px-0">
          <div className="table-container">
            {loading ? (
              <div className="spinner"></div>
            ) : (
              <table className="table mb-0">
                <thead className="py-2 bg-light text-semibold border-bottom">
                  <tr>
                    <th style={{ fontWeight: 'bold' }}>Sr.</th>

                    <th style={{ fontWeight: 'bold' }}>#ID</th>

                    <th style={{ fontWeight: 'bold' }}>AppShieldID</th>
                    <th style={{ fontWeight: 'bold' }}>Detections</th>
                    <th style={{ fontWeight: 'bold' }}>Severity</th>
                    <th style={{ fontWeight: 'bold' }}>Date</th>
                    {/* <th style={{ fontWeight: 'bold' }}>Device ID</th> */}
                    <th style={{ fontWeight: 'bold' }}>Device Name</th>
                    <th style={{ fontWeight: 'bold' }}>Device Version</th>
                  </tr>
                </thead>
                <tbody>
                  {error ? (
                    <tr>
                      <td colSpan="8" className="text-left text-danger">
                        {error}
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((item, idx) => {
                      const deviceInfo = JSON.parse(item.device_information);
                      const severity = determineSeverity(item);
                      const uuid = item.UUID;

                      return (
                        <tr
                          key={idx}
                          onClick={() => handleRowClick(uuid)}
                          style={{ cursor: 'pointer' }}
                          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                        >
                          <td>{indexOfFirstItem + idx + 1}</td> {/* Serial Number */}
                          <td>{item.id}</td>
                          <td>{uuid}</td>
                          <td>{renderDetections(item)}</td>
                          <td>
                            <Badge style={{ backgroundColor: getSeverityColor(severity), color: "#fff" }}>
                              {severity}
                            </Badge>
                          </td>
                          {/* <td>{item.received_at}</td> */}
                          <td>{formatReceivedAt(item.received_at)}</td>
                          {/* <td>{item.device_id}</td> */}
                          <td>{renderDeviceName(deviceInfo)}</td>
                          <td>{renderDeviceVersion(item)}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No data available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* <div className="pagination-container d-flex justify-content-end mt-3 pr-3">
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={handlePreviousPage}>Previous</button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => (
                <li className={`page-item ${currentPage === i + 1 ? 'active' : ''}`} key={i}>
                  <button className="page-link" onClick={() => handlePageChange(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button className="page-link" onClick={handleNextPage}>Next</button>
              </li>
            </ul>
          </div> */}





        </Container>
      </CardBody>
      <div className="pagination-container d-flex justify-content-end mt-3 pr-3">
  <ul className="pagination">
  
    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
      <button className="page-link" onClick={handlePreviousPage}>
        Previous
      </button>
    </li>


    {currentPage > 3 && (
      <>
        <li className="page-item">
          <button
            className="page-link"
            onClick={() => handlePageChange(1)}
          >
            1
          </button>
        </li>
        {currentPage > 4 && (
          <li className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        )}
      </>
    )}

  
    {Array.from(
      { length: Math.min(5, totalPages) }, // Display up to 5 pages
      (_, i) => {
        const page = currentPage + i - 1;
        if (page > 0 && page <= totalPages) {
          return (
            <li
              key={page}
              className={`page-item ${
                currentPage === page ? "active" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            </li>
          );
        }
        return null;
      }
    )}


    {currentPage < totalPages - 2 && (
      <>
        {currentPage < totalPages - 3 && (
          <li className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        )}
        <li className="page-item">
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      </>
    )}


    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
      <button className="page-link" onClick={handleNextPage}>
        Next
      </button>
    </li>
  </ul>
</div>
    </Card>
  );
};

LatestOrders.propTypes = {
  title: PropTypes.string,
};

export default LatestOrders;
